import { NeoState } from '../Reducers.interface';
import { createSelector } from 'reselect';

export const selectAllErrors = (state: NeoState) => state.app.errors;

export const selectErrorByKey = (key: string) =>
  createSelector(selectAllErrors, (errors) => errors?.[key]);
